import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {v4 as uuid} from 'uuid';
import {FormsModule} from "@angular/forms";
import {ClickOutsideDirective} from "../../directives/click.outside";

declare let _: any;
declare let jQuery: any;

@Component({
  selector: 'app-tpiq-select-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, ClickOutsideDirective],
  templateUrl: './tpiq-select-dropdown.component.html',
  styleUrl: './tpiq-select-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TpiqSelectDropdownComponent {
  filteredEntries: Array<any> = [];
  allData: Array<any> = [];
  searchEntries: Array<any> = [];
  placeHolder: string;
  entry: string;
  searchKey: string;
  displayDropdown = false;
  defaultValue: string;
  valueKey: string;
  disabled = false;
  highlightIndex = -1;
  masterRow: any;
  id: string = uuid();
  displayNone = true;
  noneLabel = '--None--';
  columnName: String;
  isOnBlur = false;

  @Input()
  set setData(data: any){
    this.allData = data ? [...data] : [];
  }

  @Input()
  set setColName(name: string){
    this.columnName = name;
  }

  @Input()
  set setPlaceHolder(placeHolder: any){
    this.placeHolder = placeHolder;
  }

  @Input()
  set setSearchKey(searchKey: any){
    this.searchKey = searchKey;
  }

  @Input()
  set setValueKey(valueKey: any){
    this.valueKey = valueKey;
  }

  @Input()
  set setDisabled(_disabled: any){
    this.disabled = _disabled;
  }

  @Input()
  set setMasterRow(master: any){
    this.masterRow = master;
  }

  @Input()
  set includeNone(includeNoneOption: boolean){
    if (includeNoneOption == false){
      this.displayNone = includeNoneOption;
    }
  }

  @Input()
  set setNoneLabel(label: string){
    this.noneLabel = label;
  }

  @Input()
  set setDefaultValue(defaultValue: any){
    setTimeout(() => {
      if (defaultValue || typeof defaultValue === 'boolean'){
        this.entry = this.getValue(defaultValue);
      } else {
        this.entry = '';
      }
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    }, 10);
  }

   @Input()
    set setOnBlur(data: any){
        this.isOnBlur = data;
    }

  @Output()
  onValueSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onTab: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onCharacterTyped: EventEmitter<any> = new EventEmitter<any>();

  constructor(private changeDetectorRef: ChangeDetectorRef){}

  /**
   * Normalize the search term: null/undefined becomes '', trim, collapse whitespace.
   */
  private normalizeSearchTerm(term: any): string {
    if (term === null || term === undefined) {
      return '';
    }
    return term.toString().trim().replace(/\s+/g, ' ');
  }

  getValue(value){
    const base = this;
    const obj = _.find(this.allData, function(obj){
      if (typeof value == 'string'){
        return obj[base.valueKey].toLowerCase() == value.toLowerCase();
      } else{
        return obj[base.valueKey] == value;
      }
    });
    return obj ? obj[this.searchKey] : '';
  }

  showDropdown(){
    if (!this.disabled){
      this.highlightIndex = 0;
      setTimeout(() => {
        this.displayDropdown = true;
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
          this.changeDetectorRef.detectChanges();
        }
      });
    }
  }

  hideDropdown(){
    setTimeout(() => {
      this.displayDropdown = false;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  triggerOnSelect($event, entryObj){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    this.entry = entryObj[this.searchKey];
    this.hideDropdown();
    if (this.masterRow){
      entryObj.master = this.masterRow;
    }
    entryObj.column = this.columnName;
    this.entry = '';
    setTimeout(() => {
      this.entry = entryObj[this.searchKey];
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
    this.onValueSelect.emit(entryObj);
  }

  triggerOnSelectNone(){
    this.entry = this.noneLabel;
    this.hideDropdown();
    this.onValueSelect.emit({});
  }

  highlightNext($event){
    const len = this.filteredEntries.length;
    if (len === 0) { this.highlightIndex = -1; return; }
    this.highlightIndex = (this.highlightIndex + 1) % len;
  }

  highlightPrevious($event){
    const len = this.filteredEntries.length;
    if (len === 0) { this.highlightIndex = -1; return; }
    if (this.highlightIndex < 0) {
      this.highlightIndex = len - 1;
      return;
    }
    this.highlightIndex = (this.highlightIndex - 1 + len) % len;
  }

  highlightAtIndex(index){
    this.highlightIndex = index;
  }

  selectEntry($event){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    const entryObj = this.filteredEntries[this.highlightIndex];
    if (!entryObj) {
      this.hideDropdown();
      return;
    }
    this.triggerOnSelect($event, entryObj);
    this.hideDropdown();
  }

  onTabPress($event){
    const base = this;
    this.hideDropdown();
    const value = this.normalizeSearchTerm($event.target.value);
    if (value){
      const filteredEntries = _.filter(this.allData, function(obj){
        return obj[base.searchKey].toLowerCase() == value.toLowerCase();
      });
      if (filteredEntries.length == 1){
        const entryObj = filteredEntries[0];
        this.entry = entryObj[this.searchKey];
        if (this.masterRow){
          entryObj.master = this.masterRow;
        }
        entryObj.column = this.columnName;
        this.onValueSelect.emit(entryObj);
      } else {
        this.onTab.emit({});
      }
    }
  }

  focusInput($event, id){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    jQuery('#' + id).focus();
  }

  onBlur($event){
    const enteredValue = this.normalizeSearchTerm($event.target.value);

    if (enteredValue){
      const lower = enteredValue.toLowerCase();
      const exists = this.allData.some(item => {
        const v = (item[this.searchKey] || '').toString().toLowerCase();
        return v === lower;
      });

      if (exists){
        // If the text doesn't match the currently selected entry, clear selection
        if ((this.entry || '').toString().toLowerCase() !== lower){
          this.onValueSelect.emit({});
        }
      } else {
        this.onValueSelect.emit({});
      }
    } else {
      this.onValueSelect.emit({});
    }
  }

  filterEntries($event){
    if ($event.key != 'Tab'){
      const base = this;
      const raw = $event.target.value || '';
      const searchString = this.normalizeSearchTerm(raw);

      if (searchString){
        this.filteredEntries = _.filter(this.allData, function(obj){
          const value = (obj[base.searchKey] || '').toString();
          return value.toLowerCase().indexOf(searchString.toLowerCase()) != -1;
        });
        this.displayDropdown = true;
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
          this.changeDetectorRef.detectChanges();
        }
      } else {
        this.filteredEntries = [];
      }
      this.highlightIndex = this.filteredEntries.length > 0 ? 0 : -1;

      const tempObj: any = { entry: {} };
      // Keep emitting the raw value so existing listeners (if any) preserve behavior
      tempObj.entry[this.searchKey] = raw;
      tempObj.entry[this.valueKey] = raw;
      this.onCharacterTyped.emit(tempObj);
    }
  }

  showAllEntries(){
    if (!this.disabled) {
      this.filteredEntries = [...this.allData];
      this.displayDropdown = true;
    }
  }

}
